export const campaignAutomationsOptions = [
  {
    label: "With automations",
    value: "GAS_ON",
  },
  {
    label: "Without automations",
    value: "",
  },
];
